import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is THE AI BOOK BUILDER™ suitable for beginners?',
  a: 'Yes. The system is designed for aspiring authors as well as writers who already have a manuscript in progress.'
}, {
  q: 'Do I need to be an AI expert?',
  a: 'No. The prompts are designed to be copied, customized and used with your preferred AI assistant.'
}, {
  q: 'Which AI tools can I use?',
  a: 'The system is designed to work with major AI assistants including ChatGPT, Claude, Gemini, DeepSeek, Grok and Qwen.'
}, {
  q: 'Will AI write the entire book for me?',
  a: 'THE AI BOOK BUILDER™ is an AI-assisted author system. It helps you structure, develop, draft, refine and evaluate your work. You remain responsible for your creative decisions, final manuscript and publishing choices.'
}, {
  q: 'Is this a one-time payment?',
  a: 'Yes. There is no subscription. You make one payment and receive lifetime access to your purchased product.'
}, {
  q: 'Do I get all four bonuses?',
  a: 'Yes. The four professional author bonuses are included with the main offer.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-44" data-mp="1foncvvd5z7te">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-45" data-mp="1fqqbv4waoba9">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-46" data-mp="11ve4ny0ycscg">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-gold/25 overflow-hidden rounded-2xl border border-gold/40 bg-white" data-id="element-47" data-mp="s0447eq7ct0s">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-48" data-mp="ixuwewmbjdr3" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-49" data-mp="izo1w8l73rxi">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-50" data-mp="2kv51x2yzplcj">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-51" data-mp="2fxlou6e13em6" /> : <PlusIcon className="h-5 w-5 shrink-0 text-gold-deep" data-id="element-52" data-mp="2axr0a9hq714a" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-53" data-mp="38lhggwoqqgc3">
                  <div className="overflow-hidden" data-id="element-54" data-mp="33n7m2oaubjrj">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-55" data-mp="2yms93xuh0ea3">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}